import React from "react";

/**
 * Logo replicating the business card "solanova gmbh" wordmark.
 * "sola" appears glossy black/charcoal, "nova" in bronze metallic.
 */
export default function Logo({ size = "md", showGmbh = true, light = false }) {
  const sizes = {
    sm: { text: "text-xl md:text-2xl", sub: "text-[9px]", gap: "mt-0.5" },
    md: { text: "text-3xl md:text-4xl", sub: "text-[10px]", gap: "mt-1" },
    lg: { text: "text-5xl md:text-6xl", sub: "text-xs", gap: "mt-2" },
    xl: { text: "text-6xl md:text-8xl", sub: "text-sm", gap: "mt-3" },
  };
  const s = sizes[size] || sizes.md;
  const solaClass = light ? "text-white/95" : "text-white/85";

  return (
    <div className="inline-flex flex-col items-center select-none" data-testid="solanova-logo">
      <div className={`solanova-logo ${s.text} leading-none`}>
        <span className={solaClass} style={{ fontWeight: 300 }}>sola</span>
        <span className="nova" style={{ fontWeight: 300 }}>nova</span>
      </div>
      {showGmbh && (
        <div className={`flex items-center gap-3 ${s.gap}`}>
          <span className="h-px w-10 bg-[var(--sol-bronze)]/60" />
          <span className={`${s.sub} tracking-[0.45em] uppercase bronze-metallic font-medium`}>g m b h</span>
          <span className="h-px w-10 bg-[var(--sol-bronze)]/60" />
        </div>
      )}
    </div>
  );
}
